import * as React from 'react';
import { useParams } from 'react-router-dom';
import type { FeedPost } from '../../../interfaces/feed.interface';
import CardComponentHeader from './CardHeader.component';
import './card.component.scss';

interface CardProps {
  children: React.ReactNode;
  userId?: string;
  username?: string;
  subheader?: string;
  edited?: number;
  titleVersions?: string[];
  cardMinWidth: number;
  raised?: boolean;
  cardActions?: boolean;
  variant?: string;
  className?: string;
  post?: FeedPost;
}

export default function CardComponent(props: CardProps): React.ReactNode {
  const {
    children,
    username,
    subheader,
    edited,
    titleVersions,
    cardMinWidth,
    raised,
    variant,
    className,
    post,
    userId,
  } = props;
  const params = useParams();
  const reversedTitleVersions = titleVersions?.length
    ? [...(titleVersions as string[])].reverse()
    : [];

  return (
    <div
      className={`Card__Component ${className ?? ''} ${raised ? 'Card__Component--raised' : ''}`}
      style={{ minWidth: cardMinWidth }}
      data-variant={variant}
    >
      <CardComponentHeader
        edited={edited as number}
        subheader={subheader as string}
        titleVersions={reversedTitleVersions as string[]}
        username={params.username as string}
        userId={userId as string}
        post={post as FeedPost}
      />
      <div className="FEED__ITEM__CONTENT">{children}</div>
    </div>
  );
}
